import get from 'lodash/get';

interface JiraFailureResponse {
	errorMessages: string[];
}

const parseMessage = (error: unknown): unknown | null => {
	if (error === null || typeof error !== 'object') {
		return null;
	}
	try {
		const message = get(error, ['message'], null);
		return JSON.parse(message);
	} catch {
		return null;
	}
};

const hasErrorMessagesProperty = (response: unknown): response is JiraFailureResponse =>
	response !== null &&
	typeof response === 'object' &&
	'errorMessages' in response &&
	Array.isArray(response.errorMessages);

export function hasJiraErrorMessages(error: unknown): error is JiraFailureResponse {
	const response = parseMessage(error);
	return hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}

export function parseJiraErrorMessages(error: unknown): string[] {
	const response = parseMessage(error);
	if (hasErrorMessagesProperty(response)) {
		return response.errorMessages;
	}
	return [];
}
